/**
 * WHICH PIECE THE SHARED EDITOR PANES SPEAK OF (v1.0.29). The video editor reuses the article
 * editor's panes, whose sentences say "article" (the owner, 22 October 2026: "в настройках
 * публикации видео все есть упоминания про статью"). Under `PieceContextProvider value="video"` a
 * pane asks for a sentence's `_video` variant (i18next context: `t(key, { context })`); with no
 * provider, as on an article's screen, `context` is '' - which i18next ignores - and the sentence
 * reads as it is.
 */
import { createContext, useContext } from 'react';

export type PieceContext = '' | 'video';

const Context = createContext<PieceContext>('');

export const PieceContextProvider = Context.Provider;

export function usePieceContext(): PieceContext {
  return useContext(Context);
}
